import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { PainPoints } from './components/PainPoints';
import { Features } from './components/Features';
import { Chapters } from './components/Chapters';
import { Testimonial } from './components/Testimonial';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (!window.fbq) {
      const n: any = window.fbq = function (...args: unknown[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', '949582520795873');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-[#0A192F] text-[#FFF8F0] selection:bg-[#D4AF37]/30 selection:text-[#FFF8F0]" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustBar data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Features data-id="element-6" />
        <Chapters data-id="element-7" />
        <Testimonial data-id="element-8" />
        <Pricing data-id="element-9" />
        <FAQ data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}